import { useMutation } from '@apollo/client';
import _ from 'lodash';
import React from 'react';
import Form, { Submit } from '../../components/Form';
import Modal, { ModalActionFooter, ModalTitle } from '../../components/Modal';
import { GitRepoPlatform } from '../../graphql/generated/graphql';
import GitRepoCheckboxes from '../integration/GitRepoCheckboxes';
import GitRepoListContainer from '../integration/GitRepoListContainer';
import ImportGithubWikiConfirmation from './GithubWikiImportConfirmation';
import styles from './GithubWikiImportModal.module.scss';
import { gql } from '../../graphql/generated/gql';

const IMPORT_GITHUB_WIKIS_MUTATION = gql(`
  mutation importGithubWikis($repos: [String!]!) {
    results: importGithubWikis(repos: $repos) {
      ...ImportGithubWikiConfirmation_results
    }
  }
`);

interface GithubWikiImportModalProps {
  close: () => void;
}

const GithubWikiImportModal = ({ close }: GithubWikiImportModalProps) => {
  const [importWikis, { data }] = useMutation(IMPORT_GITHUB_WIKIS_MUTATION);

  const results = data?.results;

  const handleImport = ({ selectedRepos }: { selectedRepos: string[] }) =>
    importWikis({ variables: { repos: selectedRepos } });

  return (
    <Modal width={425}>
      <ModalTitle close={close}>GitHub Wiki Import</ModalTitle>
      {results ? (
        <ImportGithubWikiConfirmation results={_.compact(results)} />
      ) : (
        <Form<{ selectedRepos: string[] }>
          initialValues={{ selectedRepos: [] }}
          onSubmit={handleImport}
        >
          {({ values: { selectedRepos } }) => (
            <>
              <div className={styles.selectRepos}>
                Select the repos you want to import from:
              </div>
              <GitRepoListContainer>
                <GitRepoCheckboxes
                  platform={GitRepoPlatform.Github}
                  name="selectedRepos"
                />
              </GitRepoListContainer>
              <ModalActionFooter
                primary={
                  <Submit size="large" disabled={!selectedRepos.length}>
                    Import
                  </Submit>
                }
              />
            </>
          )}
        </Form>
      )}
    </Modal>
  );
};

export default GithubWikiImportModal;
